export default "__VITE_ASSET__quPaeTmF__"